import { FunctionComponent, useMemo } from 'react'
import { TaskCategorySelectProps } from './TaskCategorySelect.model'
import { Icon, SelectInput, Tag, TooltipWrapper } from '../../../../../shared'
import {
  TASK_CATEGORY_ICON,
  TASK_CATEGORY_LABEL,
  TASK_CATEGORY_OPTIONS,
} from '../../TaskTableRow.model'
import styles from './TaskCategorySelect.module.scss'

export const TaskCategorySelect: FunctionComponent<TaskCategorySelectProps> = ({
  category,
  isEditModeEnabled,
  setCategory,
}) => {
  const categoryValue = useMemo(
    () => TASK_CATEGORY_OPTIONS.find((localCategory) => category === localCategory.value),
    [category],
  )

  return (
    <div className={styles.taskCategorySelectContainer}>
      {isEditModeEnabled ? (
        <SelectInput
          placeholder="Catégorie"
          options={TASK_CATEGORY_OPTIONS}
          value={categoryValue}
          onSelect={(category) => setCategory(category.value)}
          testId="task-category"
        />
      ) : (
        <Tag key={category} ellipsis={false} testId="task-category">
          <div className={styles.taskCategorySelectedContainer}>
            <div className={styles.taskCategorySelectedCategoryIcon}>
              {category && <Icon size="nano" icon={TASK_CATEGORY_ICON[category]} />}
            </div>
            <div>
              <TooltipWrapper
                content={
                  <div className={styles.taskCategoryTooltip}>
                    {category ? TASK_CATEGORY_LABEL[category] : ''}
                  </div>
                }
                pointerDirection="bottom"
              >
                <div className={styles.taskCategorySelectedCategoryLabel}>
                  {category ? TASK_CATEGORY_LABEL[category] : ''}
                </div>
              </TooltipWrapper>
            </div>
            <div className={styles.taskCategorySelectedChevronIcon}>
              <Icon size="femto" icon="chevron" />
            </div>
          </div>
        </Tag>
      )}
    </div>
  )
}
